<template>
  <page-outline :title="$t('pacs008.sttngs')">
    <template slot="pageContent">
      <b-form-group>
        <b-row>
          <b-col :class="{ 'active-setting': currentSetting === 'left', 'inactive-setting': currentSetting !== 'left'}">
						<h5 class="h5 font-weight-bold pb-2 text-center">Parametrer mes batchs</h5>
            <form-write-group-label-input
              :isMandatory="true"
              :inputLabel="'Paramétrer la fréquence d éxécution des PACS_008'"
              v-model="time_settings"
							inputType="text"
							class="mb-3"
							@click="changeBackground('left')"
            ></form-write-group-label-input>

            <form-write-group-label-input
              :isMandatory="true"
              :inputLabel="'Nb limite de transaction par fichiers'"
              v-model="transaction_settings"
							inputType="text"
							class="mb-3"
							@click="changeBackground('left')"
            ></form-write-group-label-input>
          </b-col>
					<!-- <b-col cols="1"><div class="hr-vertical"></div></b-col> -->
					<b-col :class="{ 'active-setting': currentSetting === 'right', 'inactive-setting': currentSetting !== 'right'}">
						<h5 class="h5 font-weight-bold pb-2 text-center">Parametrer le SFTP</h5>
						<form-write-group-label-input
							:isMandatory="true"
							:inputLabel="'URL'"
							v-model="url_settings"
							inputType="text"
							class="mb-3"
							@click="changeBackground('right')"
						></form-write-group-label-input>

						<form-write-group-label-input
							:isMandatory="true" 
							:inputLabel="'User'"
							v-model="user_settings"
							inputType="text"
							class="mb-3"
							@click="changeBackground('right')"
						></form-write-group-label-input>

						<form-write-group-label-input
							:isMandatory="true"
							:inputLabel="'Path'"
							v-model="path_settings"
							inputType="text"
							class="mb-3"
							@click="changeBackground('right')"
						></form-write-group-label-input>
					</b-col>
        </b-row>
      </b-form-group>
    </template>
  </page-outline>
</template>
<script>
import PageOutline from "@/components/common/PageOutline.vue";
import Spinner from "@/components/common/spinner.vue";
import pagination from "@/components/common/pagination.vue";
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue";

export default {
  name: "Paramètres",
  components: {
    spinner: Spinner,
    "cm-pagination": pagination,
    "page-outline": PageOutline,
    "form-write-group-label-input": formWriteGroupLabelInput,
  },
	data() {
		return {
			currentSetting: 'left'
		}
	},
	methods: {
		changeBackground (value) {
			this.currentSetting = value
		}
	}
};
</script>